export default {"src":"/_next/static/media/dogBone_24.ad78b4a2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};